<script setup lang="ts">
const props = defineProps({
  file: null,
  loading: { type: Boolean },
  error: null
})
const createContainer = useTemplateRef("createContainer")
const { width: containerWidth } = useElementSize(createContainer)
const didDownload = computed(() => isDefined(props.file.downloadSourceApplication()))
const label = computed(() => {
  if (didDownload.value)
    return "Downloaded audio"
  return "Created audio"
})
</script>

<template>
  <agent-status-preview
    ref="createContainer"
    :file
    :loading
    :error
    :label
  >
    <audio-file-player
      v-if="!loading"
      :file
      :container-width
      class="audio-content"
      show-name
    />
  </agent-status-preview>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.audio-content
  @apply shadow-card w-full h-20
</style>
